import { render, staticRenderFns } from "./BigErrorBox.vue?vue&type=template&id=01c78318&scoped=true&"
import script from "./BigErrorBox.vue?vue&type=script&lang=ts&"
export * from "./BigErrorBox.vue?vue&type=script&lang=ts&"
import style0 from "./BigErrorBox.vue?vue&type=style&index=0&id=01c78318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c78318",
  null
  
)

export default component.exports